module.exports = __webpack_public_path__ + "img/racecourse-fairview-poly-1600.8162c267.svg";